module.exports = __webpack_public_path__ + "img/vid_5_splash.297f90d9.jpg";